import s from './style.module.css'
import clsx from 'clsx'

const SearchCardImageShimmer = () => {
  return (
    <div className={s.image_container}>
      <span className={clsx(s.shimmer)} />
    </div>
  )
}

export default SearchCardImageShimmer
